import { Empty, Form, Input } from '@maxtropy/components';
import React, { useEffect, useMemo, useState } from 'react';
import styles from '../index.module.scss';
import { DateValue, DeviceRankItem, LeftData } from '../types';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash-es';
import { keepTwoNull } from '@/utils/utils';

interface LeftAreaProp {
  pageLabel?: string;
  dateRange?: DateValue;
  leftData?: LeftData;
  selectedDevice?: DeviceRankItem;
  onSelectDevice: (device: DeviceRankItem) => void;
}

const LeftArea = ({ pageLabel, dateRange, selectedDevice, onSelectDevice, leftData }: LeftAreaProp) => {
  const { conditionCount, totalCount, conditionTotal, conditionUsageAvg } = leftData ?? {};
  const [searchValue, setSearchValue] = useState<string>();
  const [deviceRankList, setDeviceRankList] = useState<DeviceRankItem[]>([]);

  useEffect(() => {
    setDeviceRankList((leftData?.dataList ?? []).map((item, index) => ({ ...item, rank: index + 1 })));
  }, [leftData]);

  // 过滤设备列表
  const filteredDeviceList = useMemo(() => {
    if (!searchValue) return deviceRankList;
    return deviceRankList.filter(d => d.deviceName?.toLowerCase().includes(searchValue.toLowerCase()));
  }, [deviceRankList, searchValue]);

  return (
    <div className={styles.leftArea}>
      {/* 总体统计 */}
      <div className={styles.totalStatistics}>
        <div>
          {pageLabel}监测设备数量共计
          <span
            style={{
              display: 'inline-block',
              padding: '0 4px',
              fontSize: 18,
              fontWeight: 500,
              color: 'var(--mx-text-base-color)',
            }}
          >
            {totalCount ?? '--'}
          </span>
          个
        </div>
        <div>
          在
          <span style={{ display: 'inline-block', padding: '0 4px', color: 'var(--mx-diagram1-color)' }}>
            {dayjs(dateRange?.[0]).format('YYYY-MM-DD')}~{dayjs(dateRange?.[1]).format('YYYY-MM-DD')}
          </span>
          中符合疑似{pageLabel}情况的设备共计
          <span
            style={{
              display: 'inline-block',
              padding: '0 4px',
              color: 'var(--mx-warning-color)',
              fontSize: 20,
              fontWeight: 500,
            }}
          >
            {conditionCount ?? '--'}
          </span>
          个
        </div>
        <div className={styles.totalUsageStatistics}>
          <div>
            <span>{pageLabel}总量：</span>
            <span>{keepTwoNull(conditionTotal)}m³</span>
          </div>
          <div>
            <span>{pageLabel}平均每小时用量：</span>
            <span>{keepTwoNull(conditionUsageAvg)}m³/h</span>
          </div>
        </div>
      </div>
      <Form.Item label="设备名称" style={{ margin: '0 20px 0 0' }}>
        <Input
          style={{ width: '100%' }}
          placeholder="设备名称"
          allowClear
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)}
        />
      </Form.Item>
      <div className={styles.flowMeter}>
        {isEmpty(filteredDeviceList) ? (
          <Empty style={{ marginTop: 80 }} />
        ) : (
          filteredDeviceList?.map(item => (
            <div
              key={item.deviceId}
              className={`${styles.meterItem} ${selectedDevice?.deviceId === item.deviceId ? styles.active : ''}`}
              onClick={() => onSelectDevice(item)}
            >
              <span className={`${styles.rankNumber} ${styles[`rankNumber_${item.rank}`]}`}>{item.rank}</span>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div className={styles.itemHeader}>{item.deviceName}</div>
                <div className={styles.itemContent}>
                  <div>
                    {pageLabel}用水量：
                    <span style={{ color: 'var(--mx-warning-color)', fontSize: 14 }}>{keepTwoNull(item.usage)}m³</span>
                  </div>
                  <div>
                    平均每小时用水量：
                    <span style={{ color: 'var(--mx-warning-color)', fontSize: 14 }}>
                      {keepTwoNull(item.usageAvg)}m³/h
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default LeftArea;
